<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch" [hidden]="!ViewReady">
    <div
        fxLayout="row"
        fxLayoutAlign="space-between start"
        fxLayoutAlign.lt-md="space-between center"
        fxLayoutGap="15px"
        class="title-line"
    >
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <button type="button" *ngIf="!!User?.AuthToken" fxHide.gt-sm mat-mini-fab color="primary" (click)="MenuOpen = !MenuOpen">
                <mat-icon>menu</mat-icon>
            </button>
            <div fxLayout="column" fxLayoutAlign="center start">
                <div [ngClass.lt-md]="'mat-display-2'" [ngClass.gt-sm]="'mat-display-1'">
                    <span fxHide.lt-md>Applicant Registration System</span>
                    <span fxHide.gt-sm>ARS</span>
                </div>
                <div fxHide.xs class="mat-caption">Polk County Public Schools</div>
            </div>
        </div>
        <app-user-header *ngIf="User" [User]="User" (logout)="ToolbarLogout()"></app-user-header>
    </div>
    <mat-sidenav-container class="sidenav" autosize="true" fxFlex>
        <mat-sidenav
            class="noprint mat-elevation-z5"
            *ngIf="!!User?.AuthToken"
            [mode]="SmallDisplay ? 'over' : 'side'"
            [(opened)]="MenuOpen"
        >
            <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
                <app-nav-menu
                    [HideChevrons]="true"
                    [user]="User"
                    [logout]="LogoutFn"
                    [about]="AboutFn"
                    (navigate)="Navigate($event)"
                ></app-nav-menu>
                <div class="app-type" *ngIf="User?.PersonnelGroup === '2'" fxFlex>
                    <em
                        >Current Application Type:
                        <span>{{ Application?.IsTeacherTransfer === true ? 'Transfer' : 'Standard' }}</span></em
                    >
                </div>
            </div>
        </mat-sidenav>
        <mat-sidenav-content #sidenavcontent>
            <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" class="fullheight fullwidth">
                <!-- <div class="devbar" *ngIf="DevSite === true && SmallDisplay"><div>Development Site</div></div> -->
                <div class="updatebar" *ngIf="UpdateAvailable">
                    <button type="button" mat-raised-button color="accent" (click)="GetUpdate()">
                        A site update is available. Click here for details.
                    </button>
                </div>
                <div fxFlex="1 1 auto" class="routerwrapper maxheight100" fxLayout="column" fxLayoutAlign="start stretch">
                    <!--
                    [class.updatebarheight]="UpdateAvailable === true"
                    [class.devbarheight]="DevSite === true" -->
                    <router-outlet class="content"></router-outlet>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
